import {
  IHighlightOptions,
  ISetHighlight2DElementIdsOptions,
} from "./interface"
import { IBasemapConfig } from "services/venue"

const defaultLayerOption = { enableAltitude: true }

const VENUE = "venue"
const LEVEL = "level"
const UNIT = "unit"
const FIXTURE = "fixture"
const KIOSK = "kiosk"
const OPENING = "opening"
const SECTION = "section"
const SECTION_MARKER = "section-marker"
const FOOTPRINT = "footprint"

const AMENITY = "amenity"
const OCCUPANT = "occupant"

const GEOLOCATION = "geolocation"
const ORIGIN_MARKER = "origin-marker"
const DESTINATION_MARKER = "destination-marker"

const DECORATION = "decoration"

export const ALWAYS_VISIBLE_FEATURE_TYPES = [VENUE, FOOTPRINT]
export const PRESERVE_OPACITY_FEATURE_TYPES = [SECTION]
export const BASE_LAYER_NAME = "base"
export const POI_MARKER_LAYER_NAME = "poi"
export const MARKER_LAYER_NAME = "marker"
export const HIGHLIGHT_LAYER_NAME = "highlight"
export const USER_LOCATION_LAYER_NAME = "user_location"

export const ORIGIN_MARKER_ID = "master-origin-marker"
export const DESTINATION_MARKER_ID = "master-destination-marker"

export const ORIGIN_MARKER_DIRECTIONS = [
  "N",
  "NE",
  "E",
  "SE",
  "S",
  "SW",
  "W",
  "NW",
]
export const ORIGIN_MARKER_SPRITE_STATES = ["idle", "walk"]
export const ORIGIN_MARKER_SPRITE_SHEET_COLUMNS = 4
export const ORIGIN_MARKER_SPRITE_SHEET_ROWS = 4
export const ORIGIN_MARKER_SPRITE_SHEET_FRAME_COUNT =
  ORIGIN_MARKER_SPRITE_SHEET_COLUMNS * ORIGIN_MARKER_SPRITE_SHEET_ROWS
export const ORIGIN_MARKER_SPRITE_ANIMATION_FPS = 15

export const USER_LOCATION_ELEMENT_ID = "user_location"
export const LAST_USER_LOCATION_ELEMENT_ID_PREFIX = "last_user_location-"

export const LOCALE_SYMBOL_KEY = "locale_symbol"
export const DEFAULT_LOCALE = "en"

export const DEFAULT_HIGHLIGHT_OPTIONS: IHighlightOptions = {
  symbolSet: null,
}

export const DEFAULT_BASEMAP: IBasemapConfig = {
  enabled: true,
  url_template: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
  subdomains: [],
  opacity: 0.6,
  css_filter: "grayscale(1)",
  max_available_zoom: 19,
}
export const DEFAULT_SET_HIGHLIGHT_2DELEMENT_IDS_OPTIONS: ISetHighlight2DElementIdsOptions =
  {
    symbolSet: null,
    defaultMarker: false,
  }

export const SUFFIX_MARKER = "marker"

export const LAYERS = [
  BASE_LAYER_NAME,
  POI_MARKER_LAYER_NAME,
  HIGHLIGHT_LAYER_NAME,
  USER_LOCATION_LAYER_NAME,
]

export const LAYER_OPTIONS = {
  [BASE_LAYER_NAME]: {
    ...defaultLayerOption,
    forceRenderOnMoving: true,
    forceRenderOnRotating: true,
    forceRenderOnZooming: true,
  },
  [POI_MARKER_LAYER_NAME]: {
    ...defaultLayerOption,
    forceRenderOnMoving: true,
    forceRenderOnRotating: true,
    forceRenderOnZooming: true,
    zIndex: 10,
    collision: true,
    collisionDelay: 1200,
  },
  [MARKER_LAYER_NAME]: { ...defaultLayerOption },
  [HIGHLIGHT_LAYER_NAME]: { ...defaultLayerOption, zIndex: 98 },
  [USER_LOCATION_LAYER_NAME]: { ...defaultLayerOption, zIndex: 99 },
}

export const LAYER_FEATURE_TYPE_OBJ = {
  [VENUE]: BASE_LAYER_NAME,
  [LEVEL]: BASE_LAYER_NAME,
  [UNIT]: BASE_LAYER_NAME,
  [FIXTURE]: BASE_LAYER_NAME,
  [KIOSK]: BASE_LAYER_NAME,
  [OPENING]: BASE_LAYER_NAME,
  [SECTION]: BASE_LAYER_NAME,
  [SECTION_MARKER]: POI_MARKER_LAYER_NAME,
  [FOOTPRINT]: BASE_LAYER_NAME,
  [AMENITY]: MARKER_LAYER_NAME,
  [OCCUPANT]: POI_MARKER_LAYER_NAME,
  [GEOLOCATION]: USER_LOCATION_LAYER_NAME,
  [ORIGIN_MARKER]: HIGHLIGHT_LAYER_NAME,
  [DESTINATION_MARKER]: HIGHLIGHT_LAYER_NAME,
  [DECORATION]: BASE_LAYER_NAME,
}

/** Custom Venue Platform Events. Prefix with "venue:" to avoid collision */
export const VENUE_EVENTS = {
  VENUE_MOVEINTOVIEW: "venue:venuemoveintoview", // When a map is moved and a venue moved into a viewport
}

// Theme symbol key for a section render type's marker (e.g. "section-<key>").
export const getSectionMarkerSymbolKey = (renderType) =>
  renderType.toLowerCase()

export const DEFAULT_EXTRUDE_CONFIGS = {
  unit: {
    walkway: {
      height: 0.1,
      offset: 0,
    },
    opentobelow: {
      height: 0.1,
    },
    terrace: {
      height: 0.1,
    },
    unenclosedarea: {
      height: 0.12,
    },
    nonpublic: {
      height: 0.1,
    },
  },
  decoration: {
    decoration: {
      height: 0.1,
    },
  },
  section: {
    parking: {
      height: 0.2,
    },
    // Fallback extrude height for a section with no category (or no
    // category-specific config), following the same self-referencing
    // convention as `decoration.decoration` above — getExtrudeConfigByFeature
    // already falls back to `${featureType}.${featureType}` when a feature
    // has no category. Themeable like every other entry here.
    section: {
      height: 0.2,
    },
  },
}
